import React from "react";
import style from "./style.module.scss";

interface Props {
  children: React.ReactNode;
  className?: string;
  desktopLayoutOnly?: boolean;
  type: "a" | "b";
  // to render children (for example, a divider) from side to side of HC
  // implemented only for type B
  movePaddingsToChildren?: boolean;
}
const Honeycomb = ({
  children,
  type,
  desktopLayoutOnly,
  className,
  movePaddingsToChildren,
}: Props) => (
  <div
    className={`${desktopLayoutOnly ? style.desktopOnly : ""} 
  ${style.wrap_honeycomb} ${style[`wrap_honeycomb_${type}`]} 
  ${movePaddingsToChildren ? style.movePaddingsToChildren : ""} 
  ${className}`}
  >
    {children}
  </div>
);
export default Honeycomb;
